import React from 'react';

class AboutMe extends React.Component {

    render(){
        return (
            <div>
                <h2>About Me</h2>
                <p>I like to write kode</p>
            </div>
        )
    }
}

export default AboutMe;